import { HTMLAttributes, ReactNode } from 'react';

type BadgeVariant = 'navy' | 'gold' | 'green' | 'gray';
type BadgeSize = 'default' | 'category';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  size?: BadgeSize;
  children: ReactNode;
}

export function Badge({ variant = 'navy', size = 'default', children, className = '', ...props }: BadgeProps) {
  const sizeStyles = {
    default: 'py-1.5 px-2.5 text-[11px]',
    category: 'py-1.5 px-2.5 text-[12px]',
  };
  
  const variantStyles = {
    navy: 'bg-[#1B365D] text-white',
    gold: 'bg-[#C9A227] text-[#1B365D]',
    green: 'bg-[#059669] text-white',
    gray: 'bg-[#E2E8F0] text-[#4A5568]',
  };
  
  return (
    <span
      className={`inline-flex items-center justify-center font-semibold rounded ${sizeStyles[size]} ${variantStyles[variant]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}
